export default __webpack_public_path__ + "static/media/496.e5531c43.png";